/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-nested-ternary */
import React, { FC, useCallback, useEffect, useRef } from 'react';
import { styled } from 'linaria/react';
import { useFormikContext } from 'formik';
import { Link } from '@mtsbank/ui-kit';
import { CdekRulesAgreement, StickyPaymentInfo } from '@features/payment/payment-form';
import MtsPaymentMethodContent from '@features/payment/method-picker/ui/MtsPaymentMethodContent';
import { PayeeWithCustomParamsType, useCyberStore } from '@entities/tsp';
import { getMtsBinding, useAuthDataStore, useBindingsStore } from '@entities/user';
import { PaymentFormValues, PaymentMethod, invokeGtmPaymentEvent } from '@entities/payment';
import { GetPriceResp } from '@entities/voucher';
import { isChromeOrEdge, parseAmount, useCurrentTspOnly, withTheme } from '@shared/lib';
import { Partners, usePartner } from '@shared/lib/partner';
import { MINCIFRY_CERTIFICATES_URL } from '@shared/config';
import { AlertBanner } from '@shared/ui/molecules';
import { Spacer, PaymentButton } from '@shared/ui/atoms';
import { Payee, PayeeBindingTypesEnum } from '@root/api/ump-catalog-manager';
import { PaymentMethodSwitcher } from '@features/payment/method-switcher';
import Title from './Title';
import Description from './Description';
import { getPaymentButtonTitle } from '../lib/getPaymentButtonTitle';
import BattleNetPromoBanner from './BattleNetPromoBanner';
import MTSDPromoBanner from './MTSDPromoBanner';
interface Props {
  showVouchersForm?: boolean;
  payee: PayeeWithCustomParamsType;
  linkedTsp: PayeeWithCustomParamsType;
  priceData: GetPriceResp;
  countryVouchers: {
    country: string;
    icon: string;
  }[];
  denominationsByCountry: Record<string, Payee[]>;
  isPaymentloading: boolean;
  isAmountInfoLoading: boolean;
  cancelGetPaymentTermsRequest: () => void;
  cancelPriceRequest: () => void;
  getCommissions: (base: number) => void;
}
const PaymentInfo: FC<Props> = ({
  showVouchersForm,
  payee,
  linkedTsp,
  priceData,
  countryVouchers,
  denominationsByCountry,
  isPaymentloading,
  isAmountInfoLoading,
  cancelGetPaymentTermsRequest,
  cancelPriceRequest,
  getCommissions
}) => {
  const {
    values,
    validateForm,
    setFieldValue,
    submitForm
  } = useFormikContext<PaymentFormValues>();
  const {
    isCurrentTspOnly
  } = useCurrentTspOnly();
  const {
    partner
  } = usePartner();
  const {
    isPromocodeActivated,
    requestID,
    paymentMethod,
    activeCountry,
    activeDenomination,
    activeCountrySteam,
    amountInfo,
    pcekMdOrder
  } = useCyberStore();
  const {
    isAuth,
    operatorMTS,
    paymentBanMTS
  } = useAuthDataStore();
  const {
    bindings
  } = useBindingsStore();
  const rulesFaqButtonRef = useRef<HTMLButtonElement>(null);

  // @ts-ignore
  const refillAmount = String(parseAmount(amountInfo?.total));
  const isAmountLoading = isAmountInfoLoading || amountInfo?.base === undefined;
  const currentBindingId = bindings?.find(binding => binding.bindingType === PayeeBindingTypesEnum.MTSACCOUNT)?.bindingId;
  const isPaymentDisabled = paymentMethod === PaymentMethod.MTS_ACCOUNT && (!isAuth || !currentBindingId || !operatorMTS || paymentBanMTS);
  const isSteam = payee?.features?.merchant_association_for_WEB as boolean;
  const isGenshin = payee?.features?.tsp_url === 'genshin';
  const isBattleNet = payee?.features?.tsp_url === 'battle-net';
  const updateCommissionRequest = (amount: number) => {
    cancelPriceRequest();
    cancelGetPaymentTermsRequest();
    getCommissions(amount);
  };
  useEffect(() => {
    if (priceData && showVouchersForm) {
      updateCommissionRequest(Number(priceData?.price));
    }
    if (!showVouchersForm && values?.price) {
      updateCommissionRequest(Number(values?.price));
    }
  }, [priceData, paymentMethod]);
  useEffect(() => {
    const allFaqAccordionButtons = document.querySelectorAll('[class*="AccordionButton"]');
    const rulesFaqButton = allFaqAccordionButtons[allFaqAccordionButtons.length - 1] as HTMLButtonElement;

    // @ts-ignore
    rulesFaqButtonRef.current = rulesFaqButton;
  }, []);
  const addFormPaymentValues = useCallback(() => {
    setFieldValue('amountInfo', amountInfo);
    setFieldValue('serviceInfo',
    // @ts-ignore
    getActualServiceForPayment({
      isSteam,
      showVouchersForm,
      linkedTsp,
      payee,
      activeDenomination,
      paymentMethod
    }));
    submitForm();
  }, [amountInfo]);
  const handleFormSubmitData = async () => {
    const formErrors = await validateForm();
    const hasErrors = Object.keys(formErrors || {}).length > 0;
    const defaultCountry = countryVouchers?.[0]?.country;
    const defaultCountrySteam: string = payee?.features?.country_web?.split(', ')[0];
    // @ts-ignore
    const defaultVoucher = denominationsByCountry?.[activeCountry]?.[0];
    if (!hasErrors) {
      invokeGtmPaymentEvent(
      // @ts-ignore
      showVouchersForm, activeCountry, defaultCountry, activeCountrySteam, defaultCountrySteam, activeDenomination, defaultVoucher, linkedTsp as Payee, payee as Payee, requestID, refillAmount, paymentMethod, pcekMdOrder);
    }
    addFormPaymentValues();
  };
  const renderButton = (id?: string) => <PaymentButtonWrapper isPaymentDisabled={isPaymentDisabled}>
      <PaymentButton id={id} onClick={handleFormSubmitData}
    // @ts-ignore
    title={getPaymentButtonTitle(showVouchersForm, isPromocodeActivated, amountInfo, isSteam)} showVouchersForm={showVouchersForm} amount={refillAmount} amountBase={amountInfo?.base} disabled={isPaymentDisabled || isPaymentloading || isAmountInfoLoading} isPaymentloading={isPaymentloading} isAmountInfoLoading={isAmountLoading} />
    </PaymentButtonWrapper>;
  const onSiteRulesClick = () => {
    if (rulesFaqButtonRef.current) {
      rulesFaqButtonRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // @ts-ignore
      if (rulesFaqButtonRef.current.nextElementSibling.getAttribute('aria-hidden') === 'true') {
        rulesFaqButtonRef.current.click();
      }
    }
  };
  const mtsBinding = getMtsBinding(bindings);
  const isMtsClient = isAuth && operatorMTS && mtsBinding && !paymentBanMTS;
  return <PaymentSideWrapper>
      <WrapperContent>
        <PaymentWrapper>
          <Wrapper>
            <Title />
            {partner !== Partners.DEFAULT && <>
                <Spacer space={8} spacetablet={8} spacemob={8} />
                <Description />
              </>}
            <Spacer space={16} spacetablet={16} spacemob={16} />
            {partner === Partners.DEFAULT && <>
                {/* @ts-ignore */}
                {/* <OldPaymentMethodSwitchexr payee={payee} /> */}
                {/* <PaymentMethodPicker
                  showVouchersForm={showVouchersForm}
                  payee={payee}
                  priceData={priceData}
                  getCommissions={getCommissions}
                 /> */}
                <Spacer space={16} />
              </>}
            {paymentMethod === PaymentMethod.MTS_ACCOUNT && <MtsPaymentMethodContent />}

            {(paymentMethod === PaymentMethod.SBP || isMtsClient) && <>
                {/* <AmountInfo showVouchersForm={showVouchersForm} isAmountInfoLoading={isAmountLoading} payee={payee} /> */}
                <Spacer space={8} spacetablet={8} spacemob={8} />
                {/* @ts-ignore */}
                <AlertBanner type="warning">
                  {isChromeOrEdge() ? <>
                      Оплата проходит стабильнее в&nbsp;Яндекс&nbsp;Браузере или&nbsp;с&nbsp;
                      <NewCardLink href={MINCIFRY_CERTIFICATES_URL} target="_blank">
                        сертификатами Минцифры
                      </NewCardLink>
                    </> : <>Для успешной оплаты рекомендуем отключить VPN и перезагрузить страницу</>}
                </AlertBanner>
              </>}

            {partner === Partners.CDEK && <>
                <Spacer space={16} />
                <CdekRulesAgreement />
              </>}

            {(paymentMethod === PaymentMethod.SBP || !isPaymentDisabled) && <>
                <Spacer space={16} spacemob={16} />
                {/* @ts-ignore */}
                <StickyPaymentInfo showVouchersForm={showVouchersForm} payee={payee}>
                  {renderButton()}
                </StickyPaymentInfo>
                {renderButton('pay')}
              </>}
            {partner === Partners.DEFAULT && <>
                <Spacer space={16} spacemob={16} />
                <DefaultWrapperText>
                  Нажимая кнопку «Оплатить», вы&nbsp;соглашаетесь с&nbsp;
                  <ButtonText onClick={onSiteRulesClick}>офертой об оказании услуг</ButtonText>
                </DefaultWrapperText>
              </>}
          </Wrapper>
        </PaymentWrapper>
      </WrapperContent>
      {partner === Partners.DEFAULT && !isCurrentTspOnly && <PromoBannerWrapper>
          <MTSDPromoBanner />
        </PromoBannerWrapper>}
    </PaymentSideWrapper>;
};
export default PaymentInfo;
const PaymentSideWrapper = /*#__PURE__*/styled('div')({
  name: "PaymentSideWrapper",
  class: "p8kv74k",
  propsAsIs: false
});
const PromoBannerWrapper = /*#__PURE__*/styled('div')({
  name: "PromoBannerWrapper",
  class: "pdisaq",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.secondary;
const WrapperContent = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperContent",
  class: "w1nx0yoc",
  propsAsIs: false,
  vars: {
    "w1nx0yoc-0": [_exp()]
  }
}));
const PaymentWrapper = /*#__PURE__*/styled('div')({
  name: "PaymentWrapper",
  class: "p3wcycw",
  propsAsIs: false
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wc96v9a",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxxs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxxxs;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const DefaultWrapperText = withTheme(/*#__PURE__*/styled('div')({
  name: "DefaultWrapperText",
  class: "d69g32x",
  propsAsIs: false,
  vars: {
    "d69g32x-0": [_exp2()],
    "d69g32x-1": [_exp3()],
    "d69g32x-2": [_exp4(), "px"],
    "d69g32x-3": [_exp5(), "px"],
    "d69g32x-4": [_exp6()]
  }
}));
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primaryLink;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.primaryLinkHover;
const ButtonText = withTheme(/*#__PURE__*/styled('p')({
  name: "ButtonText",
  class: "b1yxc0uk",
  propsAsIs: false,
  vars: {
    "b1yxc0uk-0": [_exp7()],
    "b1yxc0uk-1": [_exp8()]
  }
}));
const _exp9 = /*#__PURE__*/() => ({
  isPaymentDisabled
}) => isPaymentDisabled ? '0.5' : '1';
const _exp0 = /*#__PURE__*/() => ({
  isPaymentDisabled
}) => isPaymentDisabled ? 'none' : 'auto';
const PaymentButtonWrapper = /*#__PURE__*/styled('div')({
  name: "PaymentButtonWrapper",
  class: "ptjk7n3",
  propsAsIs: false,
  vars: {
    "ptjk7n3-0": [_exp9()],
    "ptjk7n3-1": [_exp0()]
  }
});
const _exp1 = /*#__PURE__*/() => Link;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primaryLink;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.primaryLinkHover;
const NewCardLink = withTheme(/*#__PURE__*/styled(_exp1())({
  name: "NewCardLink",
  class: "nn0scw5",
  propsAsIs: true,
  vars: {
    "nn0scw5-0": [_exp10()],
    "nn0scw5-1": [_exp11()]
  }
}));

require("./PaymentInfo.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PaymentInfo.tsx");